import { IonIcon } from '@ionic/react';
import { close, closeOutline } from 'ionicons/icons';
import { HStack, Spacer, VStack } from 'reaction';
import OverlayProvider, { Overlay, OverlayID, OverlayProps, useOverlay } from './OverlayProvider';
import styles from './FullOverlay.module.css';

interface FullOverlayProps extends OverlayProps {
    id: OverlayID;
    closeButton?: boolean;
    closeButtonPosition?: 'left' | 'right';
    title?: string;
    titleAlignment?: 'left' | 'center';
}

function FullOverlay({
    id,
    children,
    closeButton = false,
    closeButtonPosition = 'left',
    title = '',
    titleAlignment = 'center',
}: FullOverlayProps) {
    return (
        <Overlay id={id}>
            <VStack className={styles.FullOverlay}>
                <HStack justify='between' className={styles.Titlebar}>
                    <div className={styles.Third}>
                        {closeButton && closeButtonPosition === 'left' ? <CloseButton /> : null}
                    </div>
                    <div className={styles.Third} style={{ textAlign: titleAlignment }}>
                        {title}
                    </div>
                    <div className={styles.Third}>
                        {closeButton && closeButtonPosition === 'right' ? <CloseButton /> : null}
                    </div>
                </HStack>
                <Spacer />
                <div>{children}</div>
                <Spacer />
            </VStack>
        </Overlay>
    );
}

function CloseButton() {
    function closeOverlay() {
        opener(null);
    }

    const { opener } = useOverlay();

    return (
        <button onClick={closeOverlay} className={styles.CloseButton}>
            <IonIcon icon={close} />
        </button>
    );
}

export default FullOverlay;
